import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_DASHBOARD } from '../routes/paths';

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default function GuestGuard({ children }) {
  const { isAuthenticated } = useAuth();
  const { isOnboarded } = useSelector((state) => state.app);

  if (isAuthenticated) {
    if (!isOnboarded) {
      return <Navigate to="/onboarding" />;
    }
    return <Navigate to={PATH_DASHBOARD.root} />;
  }

  return <>{children}</>;
}
